const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getVariant = () => {
  let v = localStorage.getItem("gtg_ab");
  if (v !== "A" && v !== "B") {
    v = Math.random() < 0.5 ? "A" : "B";
    localStorage.setItem("gtg_ab", v);
  }
  return v;
};

export const trackAB = (event) => {
  try {
    const body = JSON.stringify({ variant: getVariant(), event });
    const sent = navigator.sendBeacon && navigator.sendBeacon(`${API}/ab/track`, new Blob([body], { type: "application/json" }));
    if (!sent) {
      fetch(`${API}/ab/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
  } catch (e) { /* non-critical */ }
};
